import React from 'react';
import { ShieldCheckIcon, FileTextIcon, ZapIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FooterSection() {
  return <footer className="bg-charcoal-975 pt-20 pb-10 px-6 md:px-8 relative" data-id="element-12">
      <div className="max-w-4xl mx-auto text-center" data-id="element-13">
        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 mb-16" data-id="element-14">
          <div className="flex items-center gap-3 text-offwhite-muted" data-id="element-15">
            <ShieldCheckIcon className="w-6 h-6 text-patriotRed" data-id="element-16" />
            <span className="text-sm font-medium uppercase tracking-wider" data-id="element-17">
              Secure Checkout
            </span>
          </div>
          <div className="flex items-center gap-3 text-offwhite-muted" data-id="element-18">
            <FileTextIcon className="w-6 h-6 text-patriotRed" data-id="element-19" />
            <span className="text-sm font-medium uppercase tracking-wider" data-id="element-20">
              PDF Format
            </span>
          </div>
          <div className="flex items-center gap-3 text-offwhite-muted" data-id="element-21">
            <ZapIcon className="w-6 h-6 text-patriotRed" data-id="element-22" />
            <span className="text-sm font-medium uppercase tracking-wider" data-id="element-23">
              Instant Delivery
            </span>
          </div>
        </div>

        {/* Final CTA */}
        <div className="mb-20" data-id="element-24">
          <h2 className="text-3xl md:text-5xl font-bold text-offwhite mb-8 font-serif" data-id="element-25">
            Get the Full Vision Now.
          </h2>
          <div className="flex flex-col items-center gap-4" data-id="element-26">
            <a href="https://templeofpages.com/cart/48643597205747:1" onClick={() => trackAddToCart()} className="inline-block bg-patriotRed hover:bg-patriotRed-hover text-offwhite px-10 py-5 uppercase tracking-wider font-semibold text-base transition-colors duration-300 w-full md:w-auto shadow-xl shadow-patriotRed/10 text-center no-underline" aria-label="Get the Full Vision Now" data-id="element-27">
              Get the Full Vision Now
            </a>
            <p className="text-offwhite-muted text-sm font-medium" data-id="element-28">
              $13.99 — Instant PDF Download
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-charcoal-800 pt-8" data-id="element-29">
          <p className="text-charcoal-700 text-sm" data-id="element-30">
            &copy; 2025 All Rights Reserved. This is a work of investigative
            journalism.
          </p>
        </div>
      </div>

      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-patriotRed" aria-hidden="true" data-id="element-31" />
    </footer>;
}